<script setup>

import {downloadFile} from "@/utils";
import {config} from "@/config";

const props = defineProps({
  files: {
    type: Array,
    default: () => [],
  },
  showDelete: {
    type: Boolean,
    default: true
  },
  fileUrl: {
    type: Function,
  },
})

const emit = defineEmits(['delete:file'])

/**
 * Helper method that downloads the file.
 * @param file
 */
function openFile(file) {
  let url = null

  if (file.toBeUploaded) {
    // not yet saved on server, download directly
    url = URL.createObjectURL(file.raw)
  } else if (props.fileUrl) {
    url = props.fileUrl(file)
    url = url.startsWith('http') ? url : config.serverUrl + url
  }

  if (url) {
    downloadFile(url, file.name)
  }
}

function deleteFile(id) {
  emit('delete:file', id)
}
</script>

<template>
  <div v-if="props.files.length > 0">
    <div v-for="file in files" :key="file.id" class="file" :class="file.toBeRemoved && 'to-be-removed'">
      <div class="file-name">
        {{ file.name }}
      </div>
      <div v-if="file.toBeRemoved" class="ml-2">({{ $t("support.file_will_be_deleted") }})</div>
      <v-spacer/>
      <v-btn class="mx-3" variant="flat" icon="download" size="small" density="comfortable" @click="openFile(file)"></v-btn>
      <v-btn icon="delete" variant="flat" color="error" size="small" density="comfortable" @click="deleteFile(file.id)"></v-btn>
    </div>
  </div>
</template>

<style scoped>
.file {
  background-color: #78BE13;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  border-radius: 15px;
  margin: 5px 0;
}

.file.to-be-removed {
  background-color: #e8e8e8;
  color: grey;
}

.file.to-be-removed .file-name {
  text-decoration: line-through;
}
</style>